<template>
  <div class="news-wrap">
    <div class="news-wrap-title">新闻动态</div>
    <div class="new-sub-title">NEWS INFORMATION</div>
    <div class="tab">
      <div
        :class="{ 'item-tab': true, 'item-tab-active': val === '0' }"
        @click="changeTab('0')"
      >
        全部
      </div>
      <div
        :class="{ 'item-tab': true, 'item-tab-active': val === '1' }"
        @click="changeTab('1')"
      >
        企业新闻
      </div>
      <div
        :class="{ 'item-tab': true, 'item-tab-active': val === '2' }"
        @click="changeTab('2')"
      >
        行业动态
      </div>
      <div
        :class="{ 'item-tab': true, 'item-tab-active': val === '3' }"
        @click="changeTab('3')"
      >
        图片快讯
      </div>
    </div>
    <div class="news-list">
      <div class="left">
        <div
          class="long-news"
          v-for="(item, index) in list.slice(0, 3)"
          :key="index"
          @click="handleDetail(item)"
        >
          <div style="display: flex; gap: 20px">
            <img
              :src="item.noticeType == '3' ? baseUrl + item.cover : item.cover"
              alt=""
              style="width: 272px"
            />
            <div class="news-info">
              <div class="news-info-title">{{ item.noticeTitle }}</div>
              <div class="news-info-content">{{ item.intro }}</div>
            </div>
          </div>
          <div style="margin-right: 42px; margin-top: 52px">
            <div style="font-size: 24px; color: #999; font-weight: 400">
              {{ item.releaseTime.split(" ")[0].split("-")[1] }} -
              {{ item.releaseTime.split(" ")[0].split("-")[2] }}
            </div>
            <div style="font-weight: 400; font-size: 16px; color: #999">
              {{ item.releaseTime.split("-")[0] }}
            </div>
            <div
              style="
                width: 72px;
                height: 21px;
                border: 2px solid #ccc;
                border-radius: 20px;
                margin-top: 26px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img src="../../assets/news/right-arrow.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="right">
        <div
          class="brief-news"
          v-for="(item, index) in list.slice(3, 5)"
          :key="index"
        >
          <img
            :src="item.cover"
            alt=""
            style="width: 100%; object-fit: contain"
          />
          <div
            style="
              padding-left: 16px;
              margin-top: 16px;
              font-size: 18px;
              color: #777;
            "
          >
            {{ item.intro }}
          </div>
        </div>
      </div> -->
    </div>
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 27px;
      "
    >
      <el-pagination
        class="pagination-wrap"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="3"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
      >
      </el-pagination>
      <div class="btn-group">
        <div
          class="prev"
          @click="changePage('prev')"
          @mouseenter="changeBtnStatus('come', 'prev')"
          @mouseleave="changeBtnStatus('go', 'prev')"
        >
          <img
            v-if="prevBtn"
            src="../../assets/news/right-arrow-white.png"
            style="transform: scaleX(-1)"
          />
          <img v-else src="../../assets/news/left-arrow.png" alt="" />
        </div>
        <div
          class="next"
          @click="changePage('next')"
          @mouseenter="changeBtnStatus('come', 'next')"
          @mouseleave="changeBtnStatus('go', 'next')"
        >
          <img v-if="nextBtn" src="../../assets/news/right-arrow-white.png" />
          <img v-else src="../../assets/news/right-arrow.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      val: "0",
      query: {
        pageNum: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      prevBtn: false,
      nextBtn: false,
      currentPage: 1,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleDetail(info) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: info.noticeId, noticeType: info.noticeType },
      });
    },
    changePage(type) {
      if (type === "prev") {
        console.log(this.query);
        if (this.query.pageNum === 1) {
          this.$message.warning("已经到首页了");
          return;
        } else {
          this.query.pageNum -= 1;
        }
      }
      if (type === "next") {
        this.query.pageNum += 1;
      }
      this.getList();
      this.currentPage = this.query.pageNum;
    },
    getList() {
      this.list = [];
      fetch(
        `/prod-api/system/notice/pageList?pageNum=${this.query.pageNum}&pageSize=3&noticeType=${this.val}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          this.list = res.rows;
          this.total = res.total;
        });
    },
    changeTab(val) {
      this.val = val;
      this.getList();
    },
    changeBtnStatus(type, btn) {
      if (btn === "prev") {
        if (type === "come") {
          this.prevBtn = true;
        }
        if (type === "go") {
          this.prevBtn = false;
        }
      }
      if (btn === "next") {
        if (type === "come") {
          this.nextBtn = true;
        }
        if (type === "go") {
          this.nextBtn = false;
        }
      }
    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
// 新闻动态 start
.news-wrap {
  padding-top: 100px;
  width: 1200px;
  margin: 0 auto;
  .news-wrap-title {
    color: #296db2;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
  }
  .new-sub-title {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
  .news-list {
    display: flex;
    justify-content: space-between;
    margin-top: 45px;
    .item-news {
      width: 376px;
      .news-date {
        margin-top: 22px;
        color: #999999;
        font-size: 16px;
        font-weight: 300;
      }
      .news-title {
        margin-top: 8px;
        color: #333333;
        font-size: 18px;
        font-weight: 400;
      }
      .news-desc {
        font-weight: 300;
        color: #666666;
        font-size: 14px;
      }
    }
  }
}
// 新闻动态 end
.tab {
  display: flex;

  .item-tab {
    width: 136px;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    user-select: none;
    cursor: pointer;
    font-size: 18px;
  }
  .item-tab-active {
    background: #1a8bd2;
    color: #fff;
  }
}
.left {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.long-news {
  width: 100%;
  height: 207px;
  background: #f6f8fa;
  display: flex;
  justify-content: space-between;
  padding: 7px;
  box-sizing: border-box;
  .news-info {
    width: 60%;
    .news-info-title {
      color: #777777;
      font-size: 20px;
      font-weight: 400;
    }
    .news-info-content {
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      margin-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;
      height: 116px;
    }
  }
}
.right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.brief-news {
  width: 390px;
  height: 320px;
  background: #f6f8fa;
  padding: 7px;
  box-sizing: border-box;
}
::v-deep.pagination-wrap {
  .btn-prev,
  .btn-next {
    width: 40px;
    height: 40px;
  }
  .el-pager {
    .number {
      border-radius: 50%;
      background: #fff;
      border: 1px solid #ccc;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
    }
    .btn-quickprev,
    .btn-quicknext {
      width: 40px;
      height: 40px;
      line-height: 40px;
    }
  }
}
.btn-group {
  width: 160px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  .prev {
    width: 80px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border: 1px solid #ccc;
    user-select: none;
  }

  .next {
    width: 80px;
    height: 40px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    user-select: none;
  }
  .prev:hover,
  .next:hover {
    background: #1a8bd2;
  }
}
</style>
